import { render, staticRenderFns } from "./LeftBarItem.vue?vue&type=template&id=417869c2&"
import script from "./LeftBarItem.vue?vue&type=script&lang=js&"
export * from "./LeftBarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports